import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Divider, Grid, Stack, Typography } from '@mui/material';
import { addMonths, differenceInDays, endOfMonth, format, startOfMonth, subDays, subMonths, subYears, } from 'date-fns';
import { ArrowRight, ChevronLeft, ChevronRight } from 'mdi-material-ui';
import { useState } from 'react';
import CalendarView from './CalendarView';
const sideBarData = [
    'Today',
    'Yesterday',
    'Last 7 Days',
    'Last 30 Days',
    'This Month',
    'Last 3 Months',
    'Last 6 Months',
    'Last 9 Months',
    'Last 1 Year',
    'Last 15 Months',
    'Last 18 Months',
    'Custom Range',
];
function DatePicker(props) {
    const { selectedOption, setSelectedOption, setSelectedMonth, selectedMonth, handleClose, } = props;
    const [duration, setDuration] = useState(props.duration);
    const { from, to } = duration;
    const handleRangeChange = (from, to) => {
        setDuration({ from, to });
    };
    const handleOptions = (value) => {
        setSelectedOption(value);
        let duration = {
            from: new Date(),
            to: new Date(),
        };
        switch (value) {
            case 'Today':
                duration = { from: new Date(), to: new Date() };
                break;
            case 'Yesterday':
                duration = { from: subDays(new Date(), 1), to: subDays(new Date(), 1) };
                break;
            case 'Last 7 Days':
            case 'Custom Range':
                duration = { from: subDays(new Date(), 6), to: new Date() };
                break;
            case 'Last 30 Days':
                duration = { from: subDays(new Date(), 29), to: new Date() };
                break;
            case 'This Month':
                duration = {
                    from: startOfMonth(new Date()),
                    to: endOfMonth(new Date()),
                };
                break;
            case 'Last 3 Months':
                duration = { from: subDays(new Date(), 89), to: new Date() };
                break;
            case 'Last 6 Months':
                duration = { from: subMonths(new Date(), 6), to: new Date() };
                break;
            case 'Last 9 Months':
                duration = { from: subMonths(new Date(), 9), to: new Date() };
                break;
            case 'Last 15 Months':
                duration = { from: subMonths(new Date(), 15), to: new Date() };
                break;
            case 'Last 18 Months':
                duration = { from: subMonths(new Date(), 18), to: new Date() };
                break;
            case 'Last 1 Year':
                duration = { from: subYears(new Date(), 1), to: new Date() };
                break;
        }
        setDuration(duration);
        setSelectedMonth(duration.to);
    };
    const handleApplyBtn = () => {
        if (!to) {
            props.setDuration({ from: duration.from, to: duration.from });
            setDuration({ from: duration.from, to: duration.from });
        }
        else {
            props.setDuration(duration);
            setDuration(duration);
        }
        ;
        handleClose();
    };
    const showDifferenceDays = () => {
        const dayDifference = differenceInDays(new Date(to), new Date(from)) + 1;
        if (dayDifference > 1)
            return `${dayDifference} Days`;
        return '1 Day';
    };
    return (_jsx(Box, Object.assign({ sx: { width: '30rem', overflow: 'hidden' } }, { children: _jsxs(Grid, Object.assign({ container: true, sx: { height: '500px', overflow: 'hidden' } }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 4, sx: {
                        borderRight: '1px solid #DCDFE4',
                        overflow: 'auto',
                        height: '430px',
                    } }, { children: sideBarData.map((value, i) => (_jsx(Box, Object.assign({ sx: {
                            backgroundColor: selectedOption === value ? '#F5F4FC' : 'common.white',
                            p: '12px 16px',
                            m: '8px 0px',
                            cursor: 'pointer',
                        }, onClick: () => handleOptions(value) }, { children: _jsx(Typography, Object.assign({ variant: "h5", sx: {
                                fontWeight: selectedOption === value
                                    ? 'fontWeightMedium'
                                    : 'fontWeightRegular',
                            } }, { children: value })) }), i))) })), _jsxs(Grid, Object.assign({ item: true, xs: 12, md: 8 }, { children: [_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "center", spacing: 5, mt: 3 }, { children: [_jsx(Typography, Object.assign({ variant: "h4", sx: { cursor: 'pointer' }, onClick: () => setSelectedMonth(from) }, { children: format(from, 'PP') })), _jsx(ArrowRight, { sx: { fontSize: '20px', color: 'text.mid' } }), _jsx(Typography, Object.assign({ variant: "h4", sx: { cursor: 'pointer' }, onClick: () => setSelectedMonth(to) }, { children: !to ? format(from, 'PP') : format(to, 'PP') }))] })), _jsx(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "center", mt: 3, mb: 2 }, { children: _jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: showDifferenceDays() })) })), _jsx(Divider, {}), _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "space-around", mt: 6, mb: 5 }, { children: [_jsx(ChevronLeft, { sx: {
                                        color: 'text.light',
                                        cursor: 'pointer',
                                        width: 24,
                                        height: 24,
                                    }, onClick: () => setSelectedMonth(subMonths(selectedMonth, 1)) }), _jsx(Typography, Object.assign({ variant: "h5", fontWeight: "fontWeightSemiBold" }, { children: format(new Date(selectedMonth), 'LLLL yyyy') })), _jsx(ChevronRight, { sx: {
                                        color: 'text.light',
                                        cursor: 'pointer',
                                        width: 24,
                                        height: 24,
                                    }, onClick: () => setSelectedMonth(addMonths(selectedMonth, 1)) })] })), _jsx(CalendarView, { month: selectedMonth, onRangeChange: handleRangeChange, duration: duration, setDuration: setDuration, setSelectedOption: setSelectedOption, selectedOption: selectedOption }), _jsx(Divider, {})] })), _jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center", p: 2 }, { children: [_jsx(Button, Object.assign({ variant: "outlined", onClick: () => {
                                    setDuration({ from: subDays(new Date(), 6), to: new Date() });
                                }, sx: {
                                    border: '2px solid #4E3BC9',
                                    borderRadius: '23px',
                                    fontWeight: 500,
                                    p: '4px 24px',
                                    '&:hover': { borderWidth: '2px' },
                                    marginLeft: '12px',
                                } }, { children: "Reset" })), _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "flex-end", spacing: 3 }, { children: [_jsx(Button, Object.assign({ variant: "outlined", onClick: handleClose, sx: {
                                            border: '2px solid #4E3BC9',
                                            borderRadius: '23px',
                                            fontWeight: 500,
                                            p: '4px 24px',
                                            '&:hover': { borderWidth: '2px' },
                                        } }, { children: "Cancel" })), _jsx(Button, Object.assign({ variant: "contained", onClick: handleApplyBtn, sx: {
                                            borderRadius: '23px',
                                            fontWeight: 500,
                                            p: '6px 24px',
                                        } }, { children: "Apply" }))] }))] })) }))] })) })));
}
export default DatePicker;
